<template>
  <div :class="[prefix,`${prefix}-wrap`]">
    <div class="shoppingcart-item">
      <div class="shoppingcart-img">
        <img
          :src="shoppingCartInfo.Product.PictureUrl"
          :title="shoppingCartInfo.Product.Name"
          @click.stop="onClick()"
          alt=""
        >
      </div>
      <div class="shoppingcart-content">
        <div
          class="shoppingcart-name"
          :title="shoppingCartInfo.Product.Name"
          @click.stop="onClick()"
        >{{shoppingCartInfo.Product.Name}}</div>
        <div class="shoppingcart-caculate">
          <div>
            <Quantity
              v-model="shoppingCartInfo.Quantity"
              :max='shoppingCartInfo.Product.OrderMaximumQuantity'
              @on-change='onQuantityChanged()'
            />
          </div>
          <div class="price" v-if="!shoppingCartInfo.Product.IsFaceToPrice">
            <span>小计:</span>
            ￥{{(shoppingCartInfo.Product.Price * shoppingCartInfo.Quantity) | money }}
          </div>
          <div class="price" v-if="shoppingCartInfo.Product.IsFaceToPrice">
           待询价
          </div>
        </div>
      </div>
      <div
        class="close"
        @click.stop="onDeleteClicked()"
      >
        <span class="icon iconfont iconclose"></span>
      </div>
    </div>
  </div>
</template>

<script>
import '@/styles/components/shoppingCart/shoppingCartItem.scss';
import Quantity from '@/components/shared/Quantity.vue';
// import EventBus, { EventName } from '@/utils/EventBus';
import { mapActions } from 'vuex';
const prefix = 'cpt-shoppingcart-item';
export default {
  inject: { reloadBody: 'reloadBody' },
  components: {
    Quantity
  },
  props: {
    shoppingCartInfo: Object
  },
  data () {
    return {
      prefix
    };
  },
  methods: {
    ...mapActions({
      updateShoppingCart: 'updateShoppingCart',
      deleteShoppingCart: 'deleteShoppingCart'
    }),
    onDeleteClicked () {
      this.deleteShoppingCart(this.shoppingCartInfo.Id).then(res => {
        if (res.Success) {
          this.$Message.info('已从购物车移除此商品');
          this.$emit('on-change');
        }
      });
    },
    onQuantityChanged () {
      this.updateShoppingCart({
        Id: this.shoppingCartInfo.Id,
        Quantity: this.shoppingCartInfo.Quantity,
        Attributes: [],
        AdditionalServices: []
      }).then(res => {
        if (res.Success) {
          this.$emit('on-change');
        }
      });
    },
    onClick () {
      if (this.$route.path.toLowerCase() === '/productdetail' &&
        this.$route.query.id && this.$route.query.id.toString() === this.shoppingCartInfo.Product.Id.toString()) {
        this.reloadBody();
      } else {
        this.$router.push({ path: '/productDetail', query: { id: this.shoppingCartInfo.Product.Id } });
      }
    }
  }
};
</script>

<style lang='scss'>
</style>



// WEBPACK FOOTER //
// src/components/shoppingcart/ShoppingCartItem.vue